(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('testimonials-kq-carousel')) return;

  class TestimonialsKqCarousel extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.drag = null;
      this.suppressClick = false;
      this.mobile.addEventListener('change', () => {
        this.finishDrag();
        this.updateState();
      }, options);
      this.addEventListener('pointerdown', (event) => this.startDrag(event), options);
      this.addEventListener('pointermove', (event) => this.moveDrag(event), options);
      this.addEventListener('pointerup', () => this.finishDrag(), options);
      this.addEventListener('pointercancel', () => this.finishDrag(), options);
      this.addEventListener('lostpointercapture', () => this.finishDrag(), options);
      this.addEventListener('dragstart', (event) => {
        if (this.canDrag) event.preventDefault();
      }, options);
      this.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.resizeObserver = new ResizeObserver(() => this.updateState());
      this.resizeObserver.observe(this);
      this.updateState();
    }

    disconnectedCallback() {
      this.finishDrag();
      clearTimeout(this.clickTimer);
      this.resizeObserver?.disconnect();
      this.events?.abort();
    }

    updateState() {
      this.canDrag = this.mobile.matches
        && this.dataset.mobileLayout === 'carousel'
        && this.scrollWidth > this.clientWidth + 1;
      this.toggleAttribute('data-draggable', this.canDrag);
      this.tabIndex = this.canDrag ? 0 : -1;
    }

    startDrag(event) {
      if (!this.canDrag || event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
      if (event.target.closest('a, button, input, textarea, select, summary')) return;
      this.suppressClick = false;
      clearTimeout(this.clickTimer);
      this.drag = { id: event.pointerId, x: event.clientX, scroll: this.scrollLeft, moved: false };
      this.setPointerCapture(event.pointerId);
      // Touch and trackpad gestures use native scrolling; only mouse dragging
      // is handled here. Vertical page scrolling is never canceled for touch.
    }

    moveDrag(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      if (event.buttons === 0) {
        this.finishDrag();
        return;
      }
      const delta = event.clientX - this.drag.x;
      if (!this.drag.moved && Math.abs(delta) < 6) return;
      this.drag.moved = true;
      this.classList.add('is-dragging');
      this.style.scrollSnapType = 'none';
      this.style.scrollBehavior = 'auto';
      this.scrollLeft = this.drag.scroll - delta;
      event.preventDefault();
    }

    finishDrag() {
      if (!this.drag) return;
      const { id, moved } = this.drag;
      this.drag = null;
      this.classList.remove('is-dragging');
      this.style.removeProperty('scroll-snap-type');
      this.style.removeProperty('scroll-behavior');
      this.suppressClick = moved;
      if (this.hasPointerCapture(id)) this.releasePointerCapture(id);
      // Re-enabling CSS scroll snapping settles onto the nearest card.
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
    }

    onKeydown(event) {
      if (!this.canDrag || event.target !== this || event.ctrlKey || event.metaKey || event.altKey) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const card = this.querySelector('.testimonials-kq__card');
      if (!card) return;
      event.preventDefault();
      const styles = window.getComputedStyle(this);
      const step = card.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      const behavior = this.motion.matches ? 'auto' : 'smooth';
      const rtl = styles.direction === 'rtl';
      if (event.key === 'Home' || event.key === 'End') {
        const limit = Math.max(0, this.scrollWidth - this.clientWidth);
        this.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -limit : limit), behavior });
      } else {
        this.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior });
      }
    }
  }

  customElements.define('testimonials-kq-carousel', TestimonialsKqCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-accordion')) {
  class ImageAccordion extends HTMLElement {
    connectedCallback() {
      this.stopPlayback();
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
      this.images = Array.from(this.querySelectorAll('[data-accordion-image]'));
      this.faq = this.querySelector('[data-accordion-faq]');
      this.duration = Math.max(3, Number(this.dataset.switchInterval) || 6) * 1000;
      this.remaining = this.duration;
      this.enabled = this.dataset.autoSwitch === 'true' && this.items.length > 1;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = !!this.faq?.matches(':hover') && window.matchMedia('(hover: hover)').matches;
      this.focused = false;
      this.keyboardInteraction = false;
      this.editorPaused = false;
      this.visible = !('IntersectionObserver' in window);
      this.frame = null;
      this.lastTime = null;
      this.tick = this.tick.bind(this);
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => this.openItem(Number(trigger.dataset.accordionTrigger)), options);
      });
      // Listen on the FAQ column: moving between its questions does not restart the timer.
      this.faq?.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.syncPlayback();
      }, options);
      this.faq?.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = false;
        this.syncPlayback();
      }, options);
      // Mouse clicks may leave a button focused; that must not prevent hover-out resuming.
      document.addEventListener('pointerdown', () => {
        this.keyboardInteraction = false;
        this.focused = false;
        this.syncPlayback();
      }, options);
      document.addEventListener('keydown', () => {
        this.keyboardInteraction = true;
        if (this.contains(document.activeElement)) {
          this.focused = true;
          this.syncPlayback();
        }
      }, options);
      this.addEventListener('focusin', () => {
        this.focused = this.keyboardInteraction;
        this.syncPlayback();
      }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.keyboardInteraction && !!event.relatedTarget && this.contains(event.relatedTarget);
        this.syncPlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const block = event.target.closest('[data-block-id]');
        const item = this.items.find(item => item.dataset.blockId === block?.dataset.blockId);
        if (item) {
          this.editorPaused = !!window.Shopify?.designMode;
          this.openItem(Number(item.dataset.accordionItem));
        }
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.contains(event.target)) return;
        this.editorPaused = false;
        this.syncPlayback();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.syncPlayback();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }
      this.openItem(Number(this.dataset.activeIndex) || 1);
    }
    disconnectedCallback() {
      this.stopPlayback();
      this.events?.abort();
      this.observer?.disconnect();
    }
    openItem(index) {
      if (!this.items.some(item => Number(item.dataset.accordionItem) === index)) return;
      this.stopPlayback();
      this.activeIndex = index;
      this.dataset.activeIndex = String(index);
      this.items.forEach(item => {
        const active = Number(item.dataset.accordionItem) === index;
        item.classList.toggle('is-active', active);
        item.style.setProperty('--ia-progress', '0');
        item.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', String(active));
        const panel = item.querySelector('[data-accordion-panel]');
        if (panel) {
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        }
      });
      this.images.forEach(image => {
        const active = Number(image.dataset.accordionImage) === index;
        image.classList.toggle('is-active', active);
        image.setAttribute('aria-hidden', String(!active));
      });
      this.remaining = this.duration;
      this.syncPlayback();
    }
    syncPlayback() {
      const shouldPlay = this.enabled && !this.motion.matches && !this.hovered && !this.focused && !this.editorPaused && !document.hidden && this.visible;
      if (!shouldPlay) {
        this.stopPlayback();
      } else if (this.frame === null) {
        this.lastTime = performance.now();
        this.frame = requestAnimationFrame(this.tick);
      }
    }
    stopPlayback() {
      if (this.frame !== null && this.frame !== undefined) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.lastTime = null;
    }
    tick(time) {
      this.frame = null;
      this.remaining -= Math.max(0, time - this.lastTime);
      this.lastTime = time;
      const item = this.items.find(item => Number(item.dataset.accordionItem) === this.activeIndex);
      item?.style.setProperty('--ia-progress', String(Math.min(1, Math.max(0, 1 - this.remaining / this.duration))));
      if (this.remaining <= 0) {
        const position = this.items.indexOf(item);
        this.openItem(Number(this.items[(position + 1) % this.items.length].dataset.accordionItem));
      } else {
        this.frame = requestAnimationFrame(this.tick);
      }
    }
  }
  customElements.define('image-accordion', ImageAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
